import { defineMessage } from 'services/localization';

export const messages = {
    invalidAmountText: defineMessage('amount_amount_exceeds_the_maximum_amount'),
    splitLineItemsAmountMismatch: defineMessage('total_amount_of_any_spl_the_line_items_affected'),
    noTaxIsInvalidText: defineMessage('you_cannot_select_no_tax_amounts_for_this_request'),
    invalidAccountText: defineMessage('according_to_the_rules__ect_a_different_account'),
    invalidTrackingText: defineMessage('according_to_the_rules__ct_a_different_category'),
    invalidAccountTaxMatchText: defineMessage('the_tax_tax_cannot_be_u_ith_the_account_account'),
};
